import { IComponentOptions } from "angular";
import { ContractDetailTabsController } from "./contractDetailTabsController";

export const vsName = "contractDetailsTabsComponent";

export const contractDetailsTabsComponentOptions: IComponentOptions = {
  controller: ContractDetailTabsController,
  template: require("!html-loader!./index.html").default,
  controllerAs: "componentController",
  bindings: {
    contract: "<",
  },
};
